
import { BankType } from "@/models/base";
import { BankService } from "@/services/bank-service";
import { i18n } from "@/setup/i18n-setup";
import { isStringNullOrWhitespace } from "@/utils/strings";
import Vue from "vue";
import VueI18n from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			BankService,
			selectedBankTypes: [] as BankType[]
		};
	},
	props: {
		value: {
			type: Array as ()=>(BankType | number)[],
		},
		useIds: Boolean,
		fancy: Boolean,
		label: {
			type: [String, Object as ()=>VueI18n.TranslateResult],
			default: ():string=>{
				return i18n.t("components.bank.labels.account").toString();
			}
		},
		filterOnlyWithIban: Boolean,
		disabled: Boolean,
		codaImportOnly: Boolean
	},
	computed: {
		allTypes():BankType[]{
			return this.BankService.getTypes();
		},
		bankTypeItems():ISelectItem<BankType | undefined>[]{
			let banks = this.allTypes;
			if (this.filterOnlyWithIban) {
				banks = banks.filter(b=>!isStringNullOrWhitespace(b.Iban) && !isStringNullOrWhitespace(b.Bic));
			}
			if (this.codaImportOnly) {
				banks = banks.filter(b=>b.ShowOnCodaImport);
			}
			let result:ISelectItem<BankType | undefined>[] = banks.map(t => {
				let text = t.Name;
				if (t.Iban) {
					text = `${t.Name} - ${t.Iban}`;
				}
				return {
					text,
					value: t
				};
			});
			return result;
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.selectedBankTypes = this.value.map(v=>{
					if (typeof(v) == "number"){
						return this.allTypes.find(t=>t.ID == v);
					}
					return v;
				}).filter(v=>{
					return v != null;
				}) as BankType[];
			}
		}
	},
	methods: {
		onInput(){
			if (this.useIds){
				this.$emit("input", this.selectedBankTypes.map(t=>t.ID));
			}else{
				this.$emit("input", this.selectedBankTypes.map(t=>t));
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.bank"
	},
});
